import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Filters } from "@air/next-icons";
export const SearchCommandFilterCount = (param)=>{
    let { count } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "absolute right-4 top-1/2 flex shrink-0 -translate-y-1/2 items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex size-4 items-center justify-center",
                children: /*#__PURE__*/ _jsx(Filters, {
                    className: "size-3"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex h-4 min-w-[16px] items-center justify-center rounded-sm bg-grey-4 px-1 text-10 font-bold text-grey-10",
                children: count
            })
        ]
    });
};
